import { useAuthContext } from '../../adminlogin/useAuthContext';
import { useSubCasteContext } from "./useSubCasteContext";
import API_URL from '../../api/APIUrl';

const SubCasteRow = ({id,title,caste}) => {
    const {dispatch} = useSubCasteContext();
    const {adminuser} = useAuthContext();

    const handleClick = async () =>{

        if(!adminuser) {
            return;
        }

        const response = await fetch(API_URL.DELETE_SINGLE_SUBCASTE + id,{
            method:'DELETE',
            headers:{
                'Authorization': `Bearer ${adminuser.token}` 
            }
        });
        const json = await response.json();
        console.log(json);
        if(response.ok){
            dispatch({type:'DELETE_SUBCASTE',payload:json});
        }
    }
    
    return (
        <tr key={id}>
            <th scope="row">{id}</th>
            <td>{title}</td>
            <td>{caste}</td>
            <td><span onClick={handleClick}>Delete</span></td>
        </tr>
    )
}

export default SubCasteRow;